import { jsxs as C, jsx as l } from "react/jsx-runtime";
import { getIconStyles as i } from "../styles.js";
const t = (e) => /* @__PURE__ */ C(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i(e),
    children: [
      /* @__PURE__ */ C("g", { clipPath: "url(#clip0_3629_11213)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.0339255 12C0.0339255 12.3498 0.0372855 12.4929 0.0413655 12.318C0.0454695 12.1431 0.0454695 11.8569 0.0413655 11.682C0.0372855 11.5071 0.0339255 11.6502 0.0339255 12Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.0969 0.825484C11.0786 0.394891 10.7048 0.0637531 10.2783 0.125933C8.99251 0.313408 7.8024 0.690388 6.63544 1.2772C2.57533 3.31883 0.0234375 7.4573 0.0234375 12C0.0234375 14.2791 0.652285 16.4585 1.86899 18.396C2.81176 19.8973 4.12614 21.2117 5.62744 22.1544C7.56493 23.3711 9.7443 24 12.0234 24C13.9125 24 15.7267 23.5699 17.4114 22.7228C19.5311 21.6569 21.2914 19.9835 22.468 17.916C23.055 16.8845 23.5034 15.6921 23.7606 14.5126C23.7894 14.3808 23.82 14.2076 23.8483 14.0335C23.9145 13.6264 23.63 13.2491 23.2221 13.1876C22.7999 13.124 22.411 13.4228 22.3464 13.845C22.3268 13.9729 22.3067 14.0921 22.2881 14.1792C21.8873 16.0601 21.0305 17.7093 19.7114 19.1404C18.1738 20.8086 16.0842 21.9445 13.8234 22.3411C13.1817 22.4537 12.89 22.4755 12.0234 22.4755C11.1569 22.4755 10.8652 22.4537 10.2234 22.3411C7.96269 21.9445 5.87308 20.8086 4.33545 19.1404C2.78764 17.4612 1.87079 15.469 1.59049 13.176C1.52985 12.6798 1.52985 11.3201 1.59049 10.824C1.74196 9.58494 2.05141 8.51961 2.57697 7.4279C3.59089 5.32168 5.34513 3.56745 7.45134 2.55352C8.42411 2.08522 9.34902 1.79447 10.4162 1.63029C10.8136 1.56915 11.1139 1.22714 11.0969 0.825484ZM0.0413655 12.318C0.0372855 12.4929 0.0339255 12.3498 0.0339255 12C0.0339255 11.6502 0.0372855 11.5071 0.0413655 11.682C0.0454695 11.8569 0.0454695 12.1431 0.0413655 12.318Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_3629_11213", children: /* @__PURE__ */ l(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.0234375)"
        }
      ) }) })
    ]
  }
);
export {
  t as CircleLoaderIcon
};
//# sourceMappingURL=CircleLoaderIcon.js.map
